import { createRoute } from '@tanstack/react-router';
import { ClaimDetails } from '../claim-details/index.js';
import { rootRoute } from './index.js';

export const claimDetailsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/claim-details/$claimId',
    component: ClaimDetails,
});
